import { MainAdvisorModel } from '../advisor/advisor.model';
import { ClientModel } from './client.model';

export class ClientListResponseModel {
  data: ClientModel[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  mainAdvisors: MainAdvisorModel[];
}
